/* eslint-disable jsx-a11y/label-has-for */

// dependancies
import React from "react";
import PropTypes from "prop-types";

// styles
import LabelStyled from "./Label.styled";

const Label = props => {
    const { htmlFor, text, checkbox, icon } = props;
    return (
        <LabelStyled htmlFor={htmlFor} checkbox={checkbox} className={icon && "label__with__symbol"}>
            {text}
        </LabelStyled>
    );
};

// props validation
Label.propTypes = {
    htmlFor: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    checkbox: PropTypes.string
};

export default Label;
